import { Box, Button, Icon } from '@zillow/constellation-10';
import { IconChecklistFilled } from '@zillow/constellation-icons';
import ConnectedModuleCard from '../../../ConnectedModuleCard';

import {
  EmptyStateBodyText,
  EmptyStateTitleText,
  StyledEmptyStateContainer,
  StyledIconContainer,
} from '../../../../styles';

type Props = {
  title: string;
  description: string;
  actionUrl: string;
  actionText: string;
};

const EmptyPropertyConditionModule = ({ title, description, actionUrl, actionText }: Props) => {
  const hideBorder = true;

  return (
    <ConnectedModuleCard data-testid="EmptyPropertyConditionModule">
      <StyledEmptyStateContainer>
        <StyledIconContainer>
          <Icon size="xl" css={{ color: 'icon.accent.blue.hero' }} render={<IconChecklistFilled />} />
        </StyledIconContainer>
        <EmptyStateTitleText asChild>
          <h4>{title}</h4>
        </EmptyStateTitleText>
        <EmptyStateBodyText asChild>
          <p>{description}</p>
        </EmptyStateBodyText>
        <Box css={{ marginBottom: '600' }} />
        <Button asChild size="md" tone="brand" emphasis="filled">
          <a href={actionUrl}>{actionText}</a>
        </Button>
      </StyledEmptyStateContainer>
    </ConnectedModuleCard>
  );
};

export default EmptyPropertyConditionModule;
